import Vue from "vue";

type callbackFn = (error: Error) => void;
export class LivenessGlobalError extends Error {
  constructor(msg: string) {
    super(msg);

    this.name = "LivenessGlobalError";
  }
}
export default class ErrorManager {
  static addGlobalErrorListener(callback: callbackFn) {
    window.addEventListener("error", (e: any) => {
      Vue.prototype.$rollbar.error(e.message, e);
    });

    window.addEventListener("unhandledrejection", (event: any) => {
      const { reason } = event;
      Vue.prototype.$rollbar.error(reason.message, reason);

      if (reason.name === "LivenessGlobalError") {
        callback(reason);
      }

      event.preventDefault();
    });
  }
}
